import classNames from 'classnames';
import React, { ReactNode } from 'react';

export interface InputLabelProps {
    label?: ReactNode;
    sublabel?: ReactNode;
    children: ReactNode;
}

const InputLabel = ({ label, sublabel, children }: InputLabelProps): JSX.Element => {
    if (label) {
        return (
            <>
                <label className="sgw-currency-input__label">
                    <span className={classNames('sgw-currency-input__mainlabel', { 'with-sublabel': sublabel })}>
                        {label}
                    </span>
                    {sublabel && <span className="sgw-currency-input__sublabel">{sublabel}</span>}
                    {children}
                </label>
            </>
        );
    }

    return <>{children}</>;
};

export default InputLabel;
